module.exports = __webpack_public_path__ + "static/media/PushImageFemale.fecd737b.svg";